export default "__VITE_ASSET__BMm0nT7x__"